export const mqTy = window.matchMedia(`(min-width: 480px`);
export const mqSm = window.matchMedia(`(min-width: 680px`);
export const mqMd = window.matchMedia(`(min-width: 980px`);
export const mqLg = window.matchMedia(`(min-width: 1280px`);
export const mqXl = window.matchMedia(`(min-width: 92em`);
